// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"733":"polyfill~intersectionObserver","880":"polyfill~fetch"}[chunkId] || chunkId) + "-" + {"732":"c6f84d5818978e76fbd0","733":"69e7a3eb9f4d64bcaee5","880":"2e04aa110b0a39f4bf2f"}[chunkId] + ".chunk.js";
};